// Names, blurbs and rules for the hub and each game's setup screen.

export interface GameInfo {
  key: 'one-phone' | 'charades' | 'dialogue' | 'mat-bolna';
  path: string;
  emoji: string;
  name: string;
  tagline: string;
  players: string;
  rules: string[];
}

export const GAMES: GameInfo[] = [
  {
    key: 'one-phone',
    path: '/games/one-phone',
    emoji: '📱',
    name: 'CompleteMasti on one phone',
    tagline: 'The full card game, passed around the table. No room code, no sign-up.',
    players: '3 to 10 players',
    rules: [
      "Add everyone's name, pick your packs, and put the phone in the middle.",
      'Each round one player is the judge 👑 and reads the prompt out loud.',
      'Pass the phone around. Each player unlocks their own hand, picks their funniest card, and passes it on. Nobody peeks.',
      'The judge gets the phone last, flips the cards one by one, and crowns a winner.',
      'First to the target score wins.',
    ],
  },
  {
    key: 'charades',
    path: '/games/charades',
    emoji: '🎬',
    name: 'Dumb Charades',
    tagline: 'Act out films, songs and TV shows. No talking, obviously.',
    players: '2 to 4 teams',
    rules: [
      'Split into teams. On your turn, one person is the actor and takes the phone.',
      'Start the clock, then hold the card to peek at the title. Nobody else looks.',
      'Act it out without a word. Show the category first: crank a camera for a film, sing for a song, draw a box for TV.',
      'Your team shouts guesses. Tap Got it for a point, or Skip if you are stuck.',
      'When the time runs out, pass the phone to the next team.',
    ],
  },
  {
    key: 'dialogue',
    path: '/games/dialogue',
    emoji: '🎙️',
    name: 'Finish the Dialogue',
    tagline: 'The quiz master reads a famous line with a word missing. First team to shout it wins.',
    players: '2 to 4 teams and a quiz master',
    rules: [
      'One person is the quiz master and holds the phone. Everyone else splits into teams.',
      'The quiz master reads the line out loud (or taps 🔊). The translation is under it for the non-filmy.',
      'Teams shout the missing word. First right answer wins the line.',
      'Tap Reveal to show the real word and the story behind the line, then give the point to the team that got it.',
      'Most lines after the last one wins.',
    ],
  },
  {
    key: 'mat-bolna',
    path: '/games/mat-bolna',
    emoji: '🤐',
    name: 'Mat Bolna',
    tagline: 'Describe the word without saying the obvious words everyone would reach for.',
    players: '2 to 4 teams',
    rules: [
      'Split into teams. On your turn, one person describes and holds the phone.',
      'Get your team to say the word on the card without saying it, or any of the forbidden words under it.',
      'Someone from another team watches over your shoulder. Say a forbidden word and they hit the buzzer: minus one.',
      'Got it is plus one. Skip costs nothing but time.',
      'When the clock runs out, pass the phone to the next team.',
    ],
  },
];

export function gameInfo(key: GameInfo['key']): GameInfo {
  return GAMES.find((g) => g.key === key)!;
}
